export function getParams() {
    return window.location.search.substr(1).split('&').reduce(
        (params, def) => {
            const segments = def.split('=')
            const key = segments.shift()
            const value = segments.join('=')

            if (!key) return params
            
            params[decodeURIComponent(key)] = decodeURIComponent(value)
            return params
        },
        {}
    )
}

export function getParam(name) {
    return getParams()[name]
}